/**
 * Rótulos de tipo de seguro exibidos no Capital Global.
 * O código `'3'` persiste como `typeOfInsurance` / `TipoSeguro` no InsureMO.
 */
export const CAPITAL_GLOBAL_INSURANCE_TYPE_LABELS: Record<string, string> = {
  '1': 'Novo',
  '2': 'Renovação',
  '3': 'Transferência de Congênere',
};

/** Rótulo exibido no step 1 da cotação Capital Global. */
export const CAPITAL_GLOBAL_INSURANCE_TYPE_STEP1_LABELS: Record<string, string> = {
  new: 'Seguro Novo',
  renewal: 'Transferência de Congênere',
};

export function getCapitalGlobalInsuranceTypeLabel(
  code?: string | number | null,
  fallback = '—',
): string {
  const key = String(code ?? '').trim();
  if (!key) return fallback;
  return CAPITAL_GLOBAL_INSURANCE_TYPE_LABELS[key] ?? fallback;
}
